<template>
	<div>
        <div class="form-row">
	        <div class="col-md-5 mb-3">
	            <div class="form-row">
	                <label class="col-md-4">Requerimiento o Póliza:</label>
	                <div class="col-md-8">
	                    <div class="input-group">
							<input 
								type="text" 
								class="form-control form-control-sm" 
								placeholder="Ingrese Requerimiento o Póliza" 
								aria-label="Ingrese Requerimiento o Póliza" 
								aria-describedby="button-search" 
								v-on:keyup.enter="requerimientoHandler" 
								v-model="filters.requerimiento"> 
							<div class="input-group-append" id="button-search">
								<button class="btn btn-outline-secondary btn-sm" type="button" v-on:click="requerimientoHandler">
									<i class="material-icons">search</i>
								</button>
							</div>
						</div>
	                </div>
	            </div>
	        </div>

	        <div class="col-md-5 mb-3">
	            <div class="form-row">
	                <label class="col-md-4 text-md-right">Cliente:</label>
	                <div class="col-md-8">
	                	<catalogo-corporaciones v-model="cliente"></catalogo-corporaciones>
	                    <div class="input-group" v-if="false">
							<input 
								type="text" 
								class="form-control form-control-sm" 
								placeholder="Ingrese cliente" 
								aria-label="Ingrese cliente" 
								aria-describedby="button-search" 
								v-on:keyup.enter="clienteHandler" 
								v-model="filters.cliente"> 
							<div class="input-group-append" id="button-search">
								<button class="btn btn-outline-secondary btn-sm" type="button" v-on:click="clienteHandler">
									<i class="material-icons">search</i>
								</button>
							</div>
						</div>
	                </div>
	            </div>
	        </div>

	        <div class="col-md-2 mb-3">
	        	<div class="text-right">
	        		<button class="btn btn-primary" v-on:click="update">
						<i class="material-icons">refresh</i>
					</button>
	        	</div>
	        </div>
        </div>

        <div class="form-row">
	        <div class="col-md-12">
	            <ul class="nav nav-tabs" id="myTab" role="tablist">
	                <li class="nav-item">
	                    <a class="nav-link active" id="cobros-programados-tab" data-toggle="tab" href="#cobros-programados" role="tab" aria-controls="cobros-programados" aria-selected="true">
	                        Cobros Programados <span class="badge badge-light" id="totalProgramados"></span>
	                    </a>
	                </li>
	                <li class="nav-item">
	                    <a class="nav-link" id="cobros-realizados-tab" data-toggle="tab" href="#cobros-realizados" role="tab" aria-controls="cobros-realizados" aria-selected="false">
	                        Cobros Realizados <span class="badge badge-light" id="totalRealizados"></span>
	                    </a>
	                </li>
	            </ul>
	            <div class="tab-content" id="myTabContent">
	                <div class="tab-pane fade show active" id="cobros-programados" role="tabpanel" aria-labelledby="cobros-programados-tab">
	                	<cobros-programados :requerimiento="requerimiento" :cliente="cliente" ref="cobrosProgramados"></cobros-programados>
	                </div>
	                <div class="tab-pane fade" id="cobros-realizados" role="tabpanel" aria-labelledby="cobros-realizados-tab">
	                	<cobros-realizados :requerimiento="requerimiento" :cliente="cliente" ref="cobrosRealizados"></cobros-realizados>
	                </div>
	            </div>
	        </div>
	    </div>
    </div>
</template>
<script>
	export default {
		data(){
			return {
				filters: {
					requerimiento: '',
				},
				requerimiento: '',
				cliente: '',
			}
		},

		methods: {
			update: function(){
				this.$refs.cobrosRealizados.getCobrosRealizados();
				this.$refs.cobrosProgramados.getCobrosProgramados();
			},

			requerimientoHandler: function(){
				this.requerimiento = this.filters.requerimiento
			},

			/*clienteHandler: function(){
				console.log('clienteHandler')
				this.cliente = this.filters.cliente
			},*/
		},
	}
</script>